import React from 'react';
import { Modal } from 'framework/ui/ui-builder';
import { ModalForm } from 'framework/form';
import ExternalReportForm from './ExternalReportForm';
import useCustomerReportService from '../useCustomerReportService';
import { useListContext } from 'framework/list';

interface SourceFieldProps {
  initialData: {
    id: string;
    index: number;
    periodStart: string;
    periodEnd: string;
    externalReportLink: string;
    projectId: string;
  };
  modalOpen: boolean;
  setModalOpen: (status: boolean) => void;
}

const UpdateExternalReportModal = ({ initialData, modalOpen, setModalOpen }: SourceFieldProps) => {
  const { getExternalReportValidationSchema, updateExternalReport } = useCustomerReportService();
  const { updateInList } = useListContext();

  return (
    <Modal title="Update customer report" isOpen={modalOpen} onToggle={() => setModalOpen(false)}>
      <ModalForm
        initialData={initialData}
        closeModal={() => setModalOpen(false)}
        modalOpen={modalOpen}
        getValidationSchemaFunc={getExternalReportValidationSchema}
        afterSubmit={{
          execute: response =>
            updateInList?.({
              ...response,
              index: initialData.index,
            }),
          message: 'External customer report has been successfully updated.',
        }}
        submitFormFunc={async values =>
          updateExternalReport(values.id, {
            periodStart: values.periodStart,
            periodEnd: values.periodEnd,
            projectId: values.projectId,
            externalReportLink: values.externalReportLink,
          })
        }
      >
        <ExternalReportForm />
      </ModalForm>
    </Modal>
  );
};
export default UpdateExternalReportModal;
